<template>
  <v-container id="tickets" class="py-15">
    <h2 class="heading mb-7 font-weight-bold text-center">
      {{ localeData.tickets.heading }}
    </h2>
    <v-row justify="start" class="mx-auto mt-10">
      <v-col cols="12">
        <p class="text-left text-caption text-note">
          <span class="text-pre-wrap" v-html="$t('tickets.description')"></span>
        </p>
      </v-col>
      <v-col cols="12">
        <p class="text-pre-wrap" v-html="$t('tickets.note')"></p>
      </v-col>
    </v-row>

    <!-- チケット種類ごとのテーブル -->
            <div v-for="ticketType in filteredTicketTypes" :key="ticketType.id">
      <v-row justify="start" class="mx-auto mt-10">
        <v-col cols="12" sm="6" md="6">
          <h3 class="text-subtitle-1 font-weight-bold text-left">
            <span v-html="formatText(ticketType.name)"></span>
          </h3>
          <p v-if="ticketType.description" class="text-body-2 text-left mt-2">
            <span v-html="formatText(ticketType.description)"></span>
          </p>
        </v-col> 
      </v-row>
      <v-row justify="start" class="mx-auto">
        <v-col cols="12" sm="6" lg="6">
          <Swiper
            :modules="modules"
            :slides-per-view="1"
            :space-between="50"
            :autoplay="{
              delay: 3000,
              disableOnInteraction: false,
            }"
            :scrollbar="true"
            :free-mode="true"
            :free-mode-sticky="false"
            class="mySwiper"
          >
            <SwiperSlide>
              <div class="table-container">
                <table
                  border="1"
                  class="ticket-table text-caption text-sm-body-2 bg-background"
                >
                  <thead>
                    <!-- ヘッダー行（複数列がある場合のみ表示） -->
                    <tr v-if="ticketType.headers && ticketType.headers.length > 1 || (ticketType.headers && ticketType.headers[0] && ticketType.headers[0].colspan > 1)">
                      <th class="blank"></th>
                      <th v-for="(header, index) in ticketType.headers" :key="index" 
                          :colspan="header.colspan || 1"
                          class="text-center">
                        <span v-html="formatText(header.text)"></span>
                      </th>
                    </tr>
                    <!-- 価格タイプ行（複数の価格タイプがある場合のみ表示） -->
                    <tr v-if="ticketType.priceTypes && ticketType.priceTypes.length > 1">
                      <th class="blank"></th>
                      <th v-for="(priceType, index) in ticketType.priceTypes" :key="index" 
                          class="text-center"
                          :class="{ 'text-decoration-line-through': priceType.strikethrough }">
                        <span v-html="formatText(priceType.name)"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in ticketType.rows" :key="rowIndex">
                      <td v-html="formatText(row.category)"></td>
                      <td v-for="(price, priceIndex) in row.prices" :key="priceIndex" 
                          class="text-center">
                        <span v-html="formatText(price.amount)"></span>
                      </td>
                    </tr>
                  </tbody>
                                 </table>
               </div>
               <!-- チケット種類ごとの注釈 -->
               <div v-if="ticketType.note" class="mt-2">
                 <p class="text-caption text-left text-note" style="margin: 0; padding: 0 4px;">
                   <span v-html="formatText(ticketType.note)"></span>
                 </p>
               </div>
             </SwiperSlide>
           </Swiper>
         </v-col>
       </v-row>
     </div>


    

    <!-- プレイガイド　-->
    <v-row class="mt-15 mx-auto text-center">
      <v-col cols="12">
        <h4
          v-html="$t('tickets.agency.title')"
          class="text-body-1 font-weight-bold text-center text-sm-left"
        ></h4>
      </v-col>
    </v-row>

    <!-- イベント終了時の表示 -->
    <v-row v-if="isEventEnded" class="mx-auto mt-4">
      <v-col cols="12">
        <p class="text-body-1 text-note text-left">
          {{ $t('tickets.agency.event_ended') }}
        </p>
      </v-col>
    </v-row>

    <!-- Coming Soon　-->
    <!-- <v-row class="mx-auto text-center mt-4">
      <v-col cols="12">
        <p class="text-body-2 text-sm-body-1 text-center">
          {{ $t('tickets.coming_soon') }}
        </p>
      </v-col>
    </v-row> -->

      <!-- ボタン -->
      <v-row v-if="!isEventEnded" class="mx-auto mt-0" :class="{ 'justify-center justify-sm-start': buttonItems.length === 1 }">
      <v-col
        v-for="(item, index) in buttonItems"
        :key="`button-${index}`"
        :cols="buttonItems.length === 1 ? '12' : '6'"
        sm="3"
        :class="[
          'mt-sm-2',
          buttonItems.length === 1 ? 'text-center text-sm-left' : 'text-left',
          item.class
        ]"
      >
        <v-btn
          class="agency-button"
          rounded="xl"
          size="x-large"
          variant="outlined"
          :color="item.disabled ? '' : 'white'"
          :href="t(item.link)"
          elevation="7"
          width="100%"
          max-width="300px"
          target="_blank"
          :class="item.class"
          :disabled="item.disabled"
        >
           <template v-if="item.img">
            <img :src="item.img" alt="Klook" style="max-height: 30px; max-width: 100px;" />
          </template>
          <template v-else>
            <span
              v-html="t(item.text)"
              class="text-caption text-sm-body-2 text-md-body-1"
              style="text-transform: none"
            ></span>
          </template>
          <SvgIcon
            type="mdi"
            :path="mdiOpenInNew"
            size="16"
            class="ml-2"
          />
        </v-btn>
      </v-col>
    </v-row>

    <!-- 完売ボタン表示
    <div class="mt-4 text-center">
      <v-row class="justify-center">
        <v-col cols="12" sm="10" md="8">
          <v-row class="mx-auto justify-center text-pre-wrap">
            <v-col cols="6" sm="6" md="4" text-center class="mt-sm-2">
              <v-btn
                class="agency-button"
                rounded="xl"
                size="x-large"
                elevation="7"
                variant="outlined"
                width="100%"
                target="_blank"
                disabled
              >
                <span
                  v-html="$t('tickets.agency.sold_out')"
                  class="text-caption text-sm-body-2 text-md-body-1"
                  style="text-transform: none"
                ></span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div> -->

    <!-- 注意事項 -->
    <v-container>
      <v-row justify="start" class="mt-10">
        <v-col cols="12" sm="12" md="12" xl="12" class="text-left">
          <p
            v-html="$t('tickets.notice.title')"
            class="text-body-2 text-sm-body-1"
          ></p>
          <div
            :class="[
              'text-left text-pre-wrap text-caption text-sm-body-2 text-note notice-text mt-2',
              { expanded: showFullNotice },
            ]"
          >
            <div class="notice-text" :class="{ expanded: showFullNotice }">
              <span v-html="formattedNotice"></span>
            </div>
            <div
              v-if="!showFullNotice && isNoticeLong"
              class="gradient-overlay"
            ></div>
          </div>
          <v-btn
            v-if="isNoticeLong"
            @click="toggleNotice"
            class="mt-2"
            :ripple="false"
            variant="plain"
            style="margin: 0 auto; display: block"
          >
            {{
              showFullNotice
                ? $t("tickets.notice.close")
                : $t("tickets.notice.read_more")
            }}
            <SvgIcon
              type="mdi"
              :path="showFullNotice ? mdiChevronUp : mdiChevronDown"
              size="16"
              class="ml-2"
            />
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

  </v-container>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import ticketData from "@/locales/Tickets.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/scrollbar";
import { Scrollbar, FreeMode } from "swiper/modules";
import { mdiOpenInNew, mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { useFilteredList, excludeById } from "@/composables/useFilteredList.js";
import { isEventEnded } from "@/config/eventStatus";

const { t, locale } = useI18n();
const localeData = computed(() => {
  console.log('Debug - ticketData:', ticketData);
  console.log('Debug - locale.value:', locale.value);
  console.log('Debug - ticketData[locale.value]:', ticketData[locale.value]);
  const data = ticketData[locale.value];
  if (!data || !data.tickets || !data.tickets.ticketTypes) {
    console.warn('Ticket data not found for locale:', locale.value);
    return ticketData.ja; // フォールバックとして日本語を使用
  }
  
  // フィルタリングされたチケットタイプをログ出力
  const filteredTypes = data.tickets.ticketTypes.filter(ticketType => 
    ticketType && ticketType.id && ticketType.id !== 'lantern'
  );
  console.log('Debug - filtered ticket types:', filteredTypes.map(t => ({ id: t.id, name: t.name })));
  
  return data;
});

// フィルタリングされたチケットタイプ（ベストプラクティス適用）
const ticketTypes = computed(() => localeData.value?.tickets?.ticketTypes || []);
const filteredTicketTypes = useFilteredList(ticketTypes, excludeById('lantern'));

const modules = [Scrollbar, FreeMode];

const fullNotice = computed(() => t("tickets.notice.caption"));
const showFullNotice = ref(false);

/**
 * 指定したキーからリアクティブなリンク付きメッセージを取得する関数
 * @param {string} key - 翻訳データのキー
 * @returns {object} - beforeLink, afterLink, linkText, linkHrefを含むリアクティブなオブジェクト
 */
function useLinkMessage(key) {
  return computed(() => ({
    beforeLink: t(`${key}.beforeLink`),
    afterLink: t(`${key}.afterLink`),
    linkText: t(`${key}.linkText`),
    linkHref: t(`${key}.linkHref`),
  }));
}

// 必要なリンク付きメッセージをリアクティブに取得
const earlyMessage = useLinkMessage("tickets.early");
const description = useLinkMessage("tickets.description");

// Noticeが3行以上かどうかを判定
const isNoticeLong = computed(() => {
  const div = document.createElement("div");
  div.style.position = "absolute";
  div.style.visibility = "hidden";
  div.style.width = "100%";
  div.style.whiteSpace = "pre-wrap";
  div.style.lineHeight = "1.667em";
  div.style.fontSize = "14px";
  div.innerHTML = formattedNotice.value; // 改行後のテキストを使用
  document.body.appendChild(div);
  const isLong =
    div.clientHeight > 3 * parseFloat(getComputedStyle(div).lineHeight);
  document.body.removeChild(div);
  return isLong;
});

// 初期表示3行分のNotice
const limitedNotice = computed(() => {
  if (showFullNotice.value || !isNoticeLong.value) return formattedNotice.value;
  return formattedNotice.value.split("<br>").slice(0, 3).join("<br>") + "...";
});

// 改行を <br> に変換したテキスト
const formattedNotice = computed(() => {
  return fullNotice.value.replace(/\n/g, "<br>");
});

const toggleNotice = () => {
  showFullNotice.value = !showFullNotice.value;
};

// フィルタリングされたアイテムを取得
const headingItems = computed(() => 
  localeData.value.tickets.agency.items.filter(item => item.type === 'heading')
);

const buttonItems = computed(() => 
  localeData.value.tickets.agency.items.filter(item => item.type === 'button')
);

// 改行コードを<br>タグに変換する関数
const formatText = (text) => {
  if (!text) return '';
  return text.replace(/\n/g, '<br>');
};
</script>

<style scoped lang="scss">
.notice-text {
  position: relative; /* 親要素を relative にする */
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 初期表示での行数制限 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap; /* テキストの折り返しを許可 */
  transition: max-height 0.3s ease; /* 高さ変更のトランジション */
  max-height: 5em; /* 3行分の高さに相当 (line-heightが1.2emの場合) */
}

.notice-text.expanded {
  max-height: none; /* 展開時に高さ制限を解除 */
  -webkit-line-clamp: unset; /* 行数制限を解除 */
}

.gradient-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2em;
  background: linear-gradient(
    to top,
    rgba(var(--v-theme-background), 1),
    rgba(var(--v-theme-background), 0)
  );
  pointer-events: none; /* グラデーションがクリックを妨げないようにする */
}

.mySwiper {
  height: auto;
  padding-bottom: 1em;
}

.table-container {
  overflow-x: auto;
  padding-bottom: 1rem;
}

:deep(.ticket-table) {
  border-collapse: collapse;
  border-color: white;
  width: 99%;

  th,
  td {
    padding: 12px 0;
    text-align: center;
    border-bottom: 1px solid white !important;
  }
  th.blank {
    background-color: rgba(var(--v-theme-note), 1);
  }

  tr td:first-child {
    background-color: rgba(var(--v-theme-primary), 1);
  }
  thead tr:first-child th:nth-child(n + 2) {
    background-color: rgba(var(--v-theme-secondary), 1);
  }
}
.tickets {
  &-before-note {
    color: rgba(var(--v-theme-note), 1);
  }
  &-after-note {
    color: rgba(var(--v-theme-secondary), 1);
  }
}

.agency-button {
  border-width: 2px;
}

.agency-heading {
  margin-top: 1em;
}

.notice-link * {
  color: #fff !important;
  font-weight: 700;
  text-decoration: underline;
  text-align: left;
  white-space: wrap !important;
}
</style>
